export default "__VITE_PUBLIC_ASSET__e29fc593__"